import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const FilterControls = ({ sortBy, onSortChange, viewMode, onViewModeChange }) => {
  const sortOptions = [
    { value: 'fairness', label: 'Most Fair Times', description: 'Smallest time difference between participants' },
    { value: 'average', label: 'Shortest Average Time', description: 'Lowest average travel time' },
    { value: 'max', label: 'Shortest Max Time', description: 'Lowest maximum travel time' },
    { value: 'rating', label: 'Highest Rated', description: 'Best venue ratings' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 shadow-md">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1 max-w-md">
          <Select
            label="Sort Results By"
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Choose sorting method"
          />
        </div>

        <div className="flex items-center gap-2">
          <span className="caption text-muted-foreground hidden lg:inline">View:</span>
          <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
            <button
              onClick={() => onViewModeChange('split')}
              className={`
                px-3 py-2 rounded-md transition-smooth flex items-center gap-2
                ${viewMode === 'split' ?'bg-card text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
                }
                focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3
              `}
              aria-label="Split view"
            >
              <Icon name="Columns2" size={18} />
              <span className="caption font-medium hidden sm:inline">Split</span>
            </button>
            <button
              onClick={() => onViewModeChange('map')}
              className={`
                px-3 py-2 rounded-md transition-smooth flex items-center gap-2
                ${viewMode === 'map' ?'bg-card text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
                }
                focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3
              `}
              aria-label="Map view"
            >
              <Icon name="Map" size={18} />
              <span className="caption font-medium hidden sm:inline">Map</span>
            </button>
            <button
              onClick={() => onViewModeChange('list')}
              className={`
                px-3 py-2 rounded-md transition-smooth flex items-center gap-2
                ${viewMode === 'list' ?'bg-card text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
                }
                focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3
              `}
              aria-label="List view"
            >
              <Icon name="List" size={18} />
              <span className="caption font-medium hidden sm:inline">List</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;